import type { FaireProductEntity } from "../../entity_types/product";

export const p_z8dxtn9pna: FaireProductEntity = {
  token: "p_z8dxtn9pna",
  type: "product",
  name: "Neu Mug s/2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl: "https://cdn.faire.com/fastly/9acc761d542156d73c2f77888cc0f0d4d8d158228e8576389754ef8a980d71d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72e82f35336d43bb7eda96087c93b21d2a70b9cf32d9b4b818834afd7aa5ee84.png",
    "https://cdn.faire.com/fastly/7387cd7904e0cfc0a638aa0f5dac9ac39b071f101ed75e52c611f8e0d6f1fc83.png",
    "https://cdn.faire.com/fastly/5175e3f9d033858ee4c56fd432c3918f00fab15ef5a392763e58892b3a061056.jpeg",
    "https://cdn.faire.com/fastly/bec440190dce8407c16e22aa5dbeeeff9bdae690ca088e3377c37cc4084ffe7c.jpeg",
    "https://cdn.faire.com/fastly/10541535e2218f4bdb80f508689bc596e08fb961f076c906f66a421f3d60bd7a.png",
    "https://cdn.faire.com/fastly/953e3e0209965c2554143cfc98745967ff50f2c10d3cfcfb2879cde64424d7e4.png",
    "https://cdn.faire.com/fastly/2fb1b9c39bb2071c67bfbd8532d476732d0ae798a2f10018fd9c390282fd025b.png",
    "https://cdn.faire.com/fastly/0b4a67292ba9e321a5a82086b5f1ccf822e51cbaa021cc1399378b918712cd2b.png"
  ],
  priceDollars: 15,
  description: "NEU, meaning “new” in German, is a pleasing dinnerware range that pays homage to the Bauhaus ideals where form and detailing is dictated by the function and production of an object. Each piece of Neu is stackable; the punctuated details are designed to maximise storage space.\n\nMaterial: Stoneware\n\nDishwasher and microwave-safe.\n\nSize: Ø9.5 x 13.3 x 8 cm\nSet of 2\n\n𝐒𝐡𝐢𝐩𝐩𝐢𝐧𝐠 𝐚𝐧𝐝 𝐫𝐞𝐭𝐮𝐫𝐧𝐬",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:20.136Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
